import { useGetViewerQuery } from '@/generated/graphql'

export const useIsViewerUserId = (userId?: number, userName?: string) => {
  const { data } = useGetViewerQuery()
  return data?.viewer.userId === userId || (userName && data?.viewer.email.includes(userName))
}
